import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, isRef as _isRef, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f9c26b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("初始化")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("导出明细")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("修改差异金额")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("确定")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, exportHandle, getNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { 
  'POST/commission/base/page': fetchList,
  // 提成基础导出
  'POST/commission/base/export': exportApi,
  // 提成基础明细导出
  'POST/commission/base/export_detail': export_detailApi,
  // 生成提成数据
  'POST/commission/init_base': init_baseApi,
  // 删除提成数据
  'POST/commission/init_base/del': delApi,
  // 导入差异金额
  'POST/commission/import/diff_amount': diff_amountApi,
  // 下载差异金额导入模板
  'POST/commission/download/template/diff_amount': templateApi,
  // 修改差异金额
  'POST/commission/update/diff_amount': EdDiff_amountApi,
  // 修改是否计算和金额
  'POST/commission/update/ratio': updateApi,
} = Api

const seleRows: any = ref([])
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)


const searchEle = ref()
const searchObj = reactive({
  month: [], orderNo: "",
})
const deatilsRow = ref<{sumVoList?: any[], ratioVoList?: any[]}>({})

const searchHandle = (otherParam?: object) => {
  deatilsRow.value = {}

  if(!otherParam){
    delete MI_params?.ids
  }

  fetchData({
    orderNo: searchObj.orderNo,
    monthFrom: searchObj.month?.[0],
    monthTo: searchObj.month?.[1],
    ...otherParam,
  })
}
searchHandle()

// 单击展示详情
const highlightRow = ref(0)
const singleClick = (row: any) => {
  deatilsRow.value = row
  highlightRow.value = row.id
}

// 生成提成数据
const isShowInt = ref<boolean>(false)
const btnLoad = ref<boolean>(false)
const intDate = ref([])
const intHandle = () => {
  btnLoad.value = true
  init_baseApi({
    initFrom: intDate.value?.[0],
    initTo: intDate.value?.[1],
  }).then(() => {
    ElMessage.success('成功')
    isShowInt.value = false
    btnLoad.value = false
    searchHandle()
  }).finally(() => {
    btnLoad.value = false
  })
}

// 删除
const isShowDel = ref<boolean>(false)
const delHandle = () => {
  btnLoad.value = true
  delApi({
    initFrom: intDate.value?.[0],
    initTo: intDate.value?.[1],
  }).then(() => {
    ElMessage.success('删除成功')
    isShowDel.value = false
    btnLoad.value = false
    searchHandle()
  }).finally(() => {
    btnLoad.value = false
  })
}

// 导出
const expHandle = () => {
  ElMessageBox.confirm('请确认是否导出', '提示').then(() => {
    MI_identify.value = true
    return exportHandle(exportApi, MI_params)
  }).then(() => {
    ElMessage.success('导出成功')
  }).finally(() => {
    MI_identify.value = false
  })
}

// 修改
const isShowEdit = ref<boolean>(false)
let editObj = reactive({
  id: '',
  diffAmount: 0,
})
const showEdit = () => {
  editObj.id = seleRows.value[0].id
  editObj.diffAmount = seleRows.value[0].diffAmount
  isShowEdit.value = true
}
const editHandle = () => {
  btnLoad.value = true
  EdDiff_amountApi(editObj).then(() => {
    ElMessage.success('修改成功')
    isShowEdit.value = false
    searchHandle()
  }).finally(() => {
    btnLoad.value = false
  })
}

// 导出
const expCommission = () => {
  ElMessageBox.confirm('请确认是否导出明细', '提示').then(() => {
    MI_identify.value = true
    return exportHandle(export_detailApi, {
      ...MI_params,
      ids: seleRows.value.map(e => e.id)
    })
  }).then(() => {
    ElMessage.success('明细导出成功')
  }).finally(() => {
    MI_identify.value = false
  })
}

// 修改是否计算和金额
const eidtItem = (row: any) => {
  const {id, data, compute, amount} = row
  MI_identify.value = true
  updateApi({
    id, amount, compute,
    data: row.ratio,
  }).then(() => {
    row.isShowEdit = false
    ElMessage.success('更新成功')
  }).finally(() => {
    MI_identify.value = false
  })
}

// --------
const tableRowClassName = ({row}: any) => {
  if (row.id === highlightRow.value){
    return 'highlightRow'
  }
  return ''
}

const getUserSummary = (param: any) => {
  const { columns, data } = param
  const sums: (string)[] = ['合计']
  columns.forEach((column: any, index: number) => {
    if (index === 0) return;

    const values = data.map((item: any) => Number(item[column.property]))
    if (!values.every((value: number) => Number.isNaN(value))) {
      sums[index] = values.reduce((prev: number, curr: number) => {
        const value = Number(curr)
        if (!Number.isNaN(value)) {
          return prev + curr
        } else {
          return prev
        }
      }, 0)
      sums[index] = getNumber(sums[index])
    } else {
      sums[index] = ''
    }
  })

  return sums
}

const getItemSummary = (param: any) => {
  const { columns, data } = param
  const sums: (string)[] = ['合计']
  columns.forEach((column: any, index: number) => {
    if (![1, 3].includes(index)) return;

    const values = data.map((item: any) => {
      if(item.compute === false) return 0;
      return item[column.property]
    })
    
    sums[index] = values.reduce((prev: number, curr: number) => {
      const value = Number(curr)
      if (!Number.isNaN(value)) {
        return prev + curr
      } else {
        return prev
      }
    }, 0)
    if(index === 3){
      sums[index] = getNumber(sums[index])
    } else {
      sums[index] = getNumber(sums[index])+ '%'
    }
    
  })

  return sums
}

expose({
  searchHandle,
  MI_identify
})

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_SuccessFilled = _resolveComponent("SuccessFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      ref_key: "searchEle",
      ref: searchEle,
      model: _unref(searchObj),
      "label-width": "auto",
      inline: "",
      class: "searchBg mb-10",
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "月份:",
          prop: "month"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: _unref(searchObj).month,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).month) = $event)),
              "value-format": "YYYY-MM-DD",
              "range-separator": "至",
              type: "monthrange",
              "start-placeholder": "开始月份",
              "end-placeholder": "结束月份"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "订单编号:",
          prop: "orderNo"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(searchObj).orderNo,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).orderNo) = $event)),
              placeholder: "请输入订单编号",
              clearable: "",
              class: "form-input"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (searchHandle())),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (searchEle.value.resetFields()))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "disabled"]),
    _createVNode(_component_el_button, {
      onClick: _cache[4] || (_cache[4] = ($event: any) => (isShowInt.value = true)),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_button, {
      onClick: _cache[5] || (_cache[5] = ($event: any) => (isShowDel.value = true)),
      disabled: _unref(MI_identify),
      type: "danger"
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_TheUpBtn, {
      upText: '导入差异',
      upFetch: _unref(diff_amountApi),
      upParams: {},
      showBtn: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_eptBtn, {
          exportFn: _unref(templateApi),
          exportText: '下载模板',
          exportParam: {},
          isDirect: true
        }, null, 8, ["exportFn"])
      ]),
      _: 1
    }, 8, ["upFetch"]),
    _createVNode(_component_el_button, {
      onClick: _cache[6] || (_cache[6] = ($event: any) => (expHandle())),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_button, {
      onClick: _cache[7] || (_cache[7] = ($event: any) => (expCommission())),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_button, {
      onClick: _cache[8] || (_cache[8] = ($event: any) => (showEdit())),
      disabled: _unref(MI_identify) || seleRows.value.length !== 1
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }, 8, ["disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 15 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              class: "mt-10",
              border: "",
              data: _unref(MI_tableData),
              onSelectionChange: _cache[9] || (_cache[9] = (rows) => seleRows.value = rows),
              onRowClick: singleClick,
              "row-class-name": tableRowClassName,
              "max-height": _unref(MI_height) - 90 + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  fixed: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "年月",
                  prop: "month",
                  "show-overflow-tooltip": "",
                  fixed: "",
                  width: "110"
                }),
                _createVNode(_component_el_table_column, {
                  label: "订单号",
                  prop: "orderNo",
                  width: "130"
                }),
                _createVNode(_component_el_table_column, {
                  label: "订单名称",
                  prop: "name",
                  "show-overflow-tooltip": "",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  label: "PO号",
                  prop: "poNumber",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "客户",
                  prop: "customerId",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "销售额",
                  prop: "amount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "销售额(USD)",
                  prop: "usdAmount",
                  align: "right",
                  formatter: _unref(formatNumber),
                  width: "130"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "内部成本",
                  prop: "internalCost",
                  align: "right",
                  formatter: _unref(formatNumber),
                  width: "100"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "资源成本",
                  prop: "externalCost",
                  align: "right",
                  formatter: _unref(formatNumber),
                  width: "100"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "手续费",
                  prop: "fee",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Tax",
                  prop: "tax",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "差异金额",
                  prop: "diffAmount",
                  align: "right",
                  formatter: _unref(formatNumber),
                  width: "100"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "利润",
                  prop: "grossProfit",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "总提成率",
                  prop: "totalCommissionRatio",
                  align: "right",
                  width: "100"
                }, {
                  default: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString(row.totalCommissionRatio + '%'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "总提成金额",
                  prop: "totalCommissionAmount",
                  align: "right",
                  formatter: _unref(formatNumber),
                  width: "110"
                }, null, 8, ["formatter"])
              ]),
              _: 1
            }, 8, ["data", "max-height"]),
            _createVNode(_component_el_pagination, {
              background: "",
              small: "",
              total: _unref(MI_total),
              currentPage: _unref(page),
              "onUpdate:currentPage": _cache[10] || (_cache[10] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
              "page-size": _unref(size),
              "onUpdate:page-size": _cache[11] || (_cache[11] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
              class: "mt-10",
              disabled: _unref(MI_identify),
              "page-sizes": [10, 30, 50, 100, 300],
              layout: "sizes, prev, pager, next, total, jumper",
              onCurrentChange: _unref(MI_pageChange),
              onSizeChange: _unref(MI_sizeChange)
            }, null, 8, ["total", "currentPage", "page-size", "disabled", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 9 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              class: "mt-10",
              border: "",
              data: deatilsRow.value.ratioVoList,
              "show-summary": "",
              "summary-method": getItemSummary,
              onRowDblclick: _cache[12] || (_cache[12] = (row) => row.isShowEdit = true),
              "max-height": _unref(MI_height) / 1.5 + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "提成项目",
                  prop: "item",
                  fixed: "",
                  width: "115"
                }),
                _createVNode(_component_el_table_column, {
                  label: "提成率",
                  prop: "ratio",
                  align: "right",
                  formatter: (row) => row.ratio + '%'
                }, {
                  default: _withCtx(({row}) => [
                    (row.isShowEdit === true && row.type === 'RATIO')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_el_input_number, {
                            modelValue: row.ratio,
                            "onUpdate:modelValue": ($event: any) => ((row.ratio) = $event),
                            maxlength: "100",
                            controls: false,
                            style: {"width":"85px"},
                            onKeyup: _withKeys(($event: any) => (eidtItem(row)), ["enter"])
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"]),
                          _hoisted_9,
                          _createVNode(_component_el_icon, {
                            size: "16",
                            class: "pointer",
                            color: "#58d053",
                            onClick: ($event: any) => (eidtItem(row))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_SuccessFilled)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(row.ratio + '%'), 1))
                  ]),
                  _: 1
                }, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Name",
                  prop: "name",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "金额",
                  prop: "amount",
                  align: "right",
                  width: "115"
                }, {
                  default: _withCtx(({row}) => [
                    (row.isShowEdit === true && row.type === 'AMOUNT')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_el_input_number, {
                            modelValue: row.amount,
                            "onUpdate:modelValue": ($event: any) => ((row.amount) = $event),
                            maxlength: "100",
                            controls: false,
                            style: {"width":"85px"},
                            onKeyup: _withKeys(($event: any) => (eidtItem(row)), ["enter"])
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"]),
                          _hoisted_12,
                          _createVNode(_component_el_icon, {
                            size: "16",
                            class: "pointer",
                            color: "#58d053",
                            onClick: ($event: any) => (eidtItem(row))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_SuccessFilled)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(getNumber)(row.amount)), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "备注",
                  prop: "note"
                }),
                _createVNode(_component_el_table_column, {
                  label: "是否计算",
                  prop: "compute",
                  width: "110"
                }, {
                  default: _withCtx(({row}) => [
                    (row.isShowEdit === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_el_select, {
                            modelValue: row.compute,
                            "onUpdate:modelValue": ($event: any) => ((row.compute) = $event),
                            clearable: false,
                            onChange: ($event: any) => (eidtItem(row))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "是",
                                value: true
                              }),
                              _createVNode(_component_el_option, {
                                label: "否",
                                value: false
                              })
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(row.compute ? '是': '否'), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "数据类型",
                  prop: "dataType",
                  width: "100"
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"]),
            _createVNode(_component_el_table, {
              class: "mt-10",
              border: "",
              data: deatilsRow.value.sumVoList,
              "max-height": _unref(MI_height) / 3 - 80 + 'px',
              "show-summary": "",
              "summary-method": getUserSummary
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "Name",
                  prop: "name"
                }),
                _createVNode(_component_el_table_column, {
                  label: "金额",
                  prop: "amount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"])
              ]),
              _: 1
            }, 8, ["data", "max-height"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowInt.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((isShowInt).value = $event)),
      title: "生成提成数据",
      onClose: _cache[17] || (_cache[17] = ($event: any) => (intDate.value = [])),
      width: "500px",
      "show-close": !btnLoad.value,
      "close-on-click-modal": !btnLoad.value
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = ($event: any) => (isShowInt.value = false)),
          disabled: btnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (intHandle())),
          loading: btnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_date_picker, {
          modelValue: intDate.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((intDate).value = $event)),
          type: "monthrange",
          "value-format": "YYYY-MM-DD",
          "start-placeholder": "开始月份",
          "end-placeholder": "结束月份"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "show-close", "close-on-click-modal"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowDel.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((isShowDel).value = $event)),
      title: "删除提成数据",
      onClose: _cache[22] || (_cache[22] = ($event: any) => (intDate.value = [])),
      width: "500px",
      "show-close": !btnLoad.value,
      "close-on-click-modal": !btnLoad.value
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[19] || (_cache[19] = ($event: any) => (isShowDel.value = false)),
          disabled: btnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          onClick: _cache[20] || (_cache[20] = ($event: any) => (delHandle())),
          type: "danger",
          loading: btnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_date_picker, {
          modelValue: intDate.value,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((intDate).value = $event)),
          type: "monthrange",
          "value-format": "YYYY-MM-DD",
          "start-placeholder": "开始月份",
          "end-placeholder": "结束月份"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "show-close", "close-on-click-modal"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowEdit.value,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((isShowEdit).value = $event)),
      title: "修改差异金额",
      width: "300"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[24] || (_cache[24] = ($event: any) => (isShowEdit.value = false)),
          disabled: btnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (editHandle())),
          loading: btnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input_number, {
          modelValue: _unref(editObj).diffAmount,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(editObj).diffAmount) = $event)),
          controls: false,
          disabled: btnLoad.value
        }, null, 8, ["modelValue", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})